import { Loader2 } from "lucide-react";
import type { Proforma } from "@/lib/proforma.api";
import type { ProformaViewMode } from "../proforma.constants";
import { ProformaGrid } from "./ProformaGrid";
import { ProformasTable } from "./ProformasTable";

interface ProformasContentProps {
  proformas: Proforma[];
  viewMode: ProformaViewMode;
  isLoading: boolean;
  onSelect: (proforma: Proforma) => void;
}

export function ProformasContent({
  proformas,
  viewMode,
  isLoading,
  onSelect,
}: ProformasContentProps) {
  if (isLoading) {
    return <Loader2 className="animate-spin text-subtle" size={18} />;
  }

  if (viewMode === "grid") {
    return <ProformaGrid proformas={proformas} onSelect={onSelect} />;
  }

  return <ProformasTable proformas={proformas} onSelect={onSelect} />;
}
